import { motion } from "framer-motion";
import { LOGO_SRC } from "../../data/menu";
import { APP } from "../../constants/testIds";

export const Footer = () => {
  return (
    <footer
      data-testid={APP.footer}
      className="relative overflow-hidden bg-[#0a0906] px-5 pb-16 pt-24 sm:px-8 sm:pb-20 sm:pt-32"
    >
      <div className="pointer-events-none absolute inset-0 opacity-[0.05] noise-texture" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-32 bg-[radial-gradient(ellipse_at_50%_0%,rgba(201,169,97,0.14),transparent_60%)]" />

      <div className="relative mx-auto flex w-full max-w-3xl flex-col items-center text-center">
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-20%" }}
          transition={{ duration: 1, ease: [0.65, 0, 0.35, 1] }}
          className="h-px w-28 origin-center bg-[#c9a961]/60"
        />

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-20%" }}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 font-playfair text-2xl italic leading-snug text-[#f4e9d5] sm:text-3xl md:text-4xl"
        >
          Hechos con ingredientes
          <br className="hidden sm:block" /> frescos y de calidad.
        </motion.p>

        <motion.img
          src={LOGO_SRC}
          data-testid={APP.footerLogo}
          alt="Los Andariegos Restaurante"
          draggable={false}
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 0.9, y: 0 }}
          viewport={{ once: true, margin: "-20%" }}
          transition={{ duration: 0.9, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12 w-48 max-w-[60vw] select-none opacity-90 sm:w-60"
        />

        <div className="mt-10 flex items-center gap-3 font-inter text-[10px] uppercase tracking-[0.32em] text-[#f4e9d5]/40">
          <span className="h-px w-6 bg-[#c9a961]/40" />
          Carta 2026
          <span className="h-px w-6 bg-[#c9a961]/40" />
        </div>

        <p className="mt-6 font-inter text-[10px] uppercase tracking-[0.28em] text-[#f4e9d5]/30">
          © {new Date().getFullYear()} Los Andariegos Restaurante
        </p>
      </div>
    </footer>
  );
};
